import React from 'react';
import AnimatedSection from './AnimatedSection';

const InstitutionsBanner = () => {
  return (
    <section className="py-10 bg-gray-50 border-y border-gray-200">
      <div className="container mx-auto px-4">
        <AnimatedSection animation="fade-up">
          <p
            className="text-center text-gray-500 font-semibold text-base md:text-lg"
            style={{ letterSpacing: '0.02em' }}
          >
            Adopted and tested at many major IDNs and health systems across the U.S.
          </p>
        </AnimatedSection>
      </div>
    </section>
  );
};

export default InstitutionsBanner;
